var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'p-cascader-panel',
    _vm.border && 'is-bordered'
  ],on:{"keydown":_vm.handleKeyDown}},_vm._l((_vm.menus),function(menu,index){return _c('cascader-menu',{key:index,ref:"menu",refInFor:true,attrs:{"index":index,"nodes":menu}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }